import { render, staticRenderFns } from "./HeadBlock.vue?vue&type=template&id=0e740d2b&scoped=true&"
import script from "./HeadBlock.vue?vue&type=script&lang=js&"
export * from "./HeadBlock.vue?vue&type=script&lang=js&"
import style0 from "./HeadBlock.vue?vue&type=style&index=0&id=0e740d2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e740d2b",
  null
  
)

export default component.exports